import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import UploadModules from "../../constants/uploadModules";
import videoService from "../../services/video/videoService";
import { extractYoutubeVideoId } from "../../utils/youtubeHelper";
import { getYoutubeThumbnail } from "../../utils/youtubeHelper";
import "./Video.css";

export default function VideoForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        title: "",

        metaTitle: "",

        metaDescription: "",

        description: "",

        youtubeVideoUrl: "",

        thumbnail: "",

        category: "",

        displayOrder: 0,

        isActive: true

    });
    useEffect(() => {

        if (isEdit) {

            loadVideo();

        }

    }, []);

    const loadVideo = async () => {

        try {

            setLoading(true);

            const response = await videoService.getById(id);

            if (response.success) {

                const data = response.data;
                console.log(response.data.thumbnail);
                setForm({

                    title: data.title || "",

                    metaTitle: data.metaTitle || "",

                    metaDescription: data.metaDescription || "",

                    description: data.description || "",

                    youtubeVideoUrl: data.youtubeVideoId
                        ? `https://www.youtube.com/watch?v=${data.youtubeVideoId}`
                        : "",

                    thumbnail: data.thumbnail || "",

                    category: data.category || "",

                    displayOrder: data.displayOrder || 0,

                    isActive: data.isActive

                });

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm(prev => ({

            ...prev,

            [name]: type === "checkbox" ? checked : value

        }));

    };
    const handleYoutubeUrlChange = (e) => {

        const url = e.target.value;

        const videoId = extractYoutubeVideoId(url);

        setForm(prev => {

            const isCustomThumbnail =
                prev.thumbnail &&
                prev.thumbnail.startsWith("/uploads/");

            return {

                ...prev,

                youtubeVideoUrl: url,

                thumbnail: isCustomThumbnail
                    ? prev.thumbnail
                    : getYoutubeThumbnail(videoId)

            };

        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.title.trim()) {

            toast.error("Title is required.");

            return;

        }

        if (!form.youtubeVideoUrl.trim()) {

            toast.error("YouTube URL is required.");

            return;

        }

        try {

            setLoading(true);

            const videoId = extractYoutubeVideoId(form.youtubeVideoUrl);

            if (!videoId) {

                toast.error("Invalid YouTube URL.");

                return;

            }

            const request = {

                title: form.title,

                metaTitle: form.metaTitle,

                metaDescription: form.metaDescription,

                description: form.description,

                youtubeVideoId: videoId,

                thumbnail: form.thumbnail,

                category: form.category,

                displayOrder: Number(form.displayOrder),

                isActive: form.isActive

            };

            let response;

            if (isEdit) {

                response = await videoService.update(id, request);

            }
            else {

                response = await videoService.create(request);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/videos");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit Video" : "Add Video"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">

                            <div className="col-lg-6">

                                <label className="form-label">
                                    Video Title <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Category
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="category"
                                    value={form.category}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Display Order
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-6">

                                <label className="form-label">
                                    Meta Title
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="metaTitle"
                                    value={form.metaTitle}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-6">

                                <label className="form-label">
                                    Meta Description
                                </label>

                                <textarea
                                    rows="2"
                                    className="form-control"
                                    name="metaDescription"
                                    value={form.metaDescription}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-12">

                                <label className="form-label">
                                    YouTube URL
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="youtubeVideoUrl"
                                    value={form.youtubeVideoUrl}
                                    onChange={handleYoutubeUrlChange}
                                    placeholder="https://youtu.be/... or https://youtube.com/watch?v=..."
                                />

                            </div>

                            <div className="col-12">

                                <label className="form-label">
                                    Description
                                </label>

                                <textarea
                                    rows="5"
                                    className="form-control"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-8">

                                <label className="form-label">
                                    Thumbnail
                                </label>
                                

<ImageUploader
    module={UploadModules.VIDEO}
    value={form.thumbnail}
    onUpload={(path) =>
        setForm({
            ...form,
            thumbnail: path
        })
    }
/>
                               

                            </div>

                            <div className="col-lg-4 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/videos")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}